import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const RoomInfoModal = ({ isOpen, onClose, roomType, hotelName, hotelId, maxCapacity, onAddRoom, hotelPrecios }) => {
  const [adults, setAdults] = useState(1);
  const [juniors, setJuniors] = useState(0);
  const [children, setChildren] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setAdults(1);
      setJuniors(0);
      setChildren(0);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const totalPassengers = adults + juniors + children;

  const increment = (setter, value) => {
    if (totalPassengers < maxCapacity) setter(value + 1);
  };

  const decrement = (setter, value) => {
    if (value > 0) setter(value - 1);
  };

  const getRoomTypeName = (type) => {
    const types = {
      roomsimple: 'Habitación Simple (1 persona)',
      roomdoble: 'Habitación Doble (2 personas)',
      roomtriple: 'Habitación Triple (3 personas)',
      roomcuadruple: 'Habitación Cuádruple (4 personas)'
    };
    return types[type] || type;
  };

  const roomKeyMap = {
    roomsimple: 'simple',
    roomdoble: 'doble',
    roomtriple: 'triple',
    roomcuadruple: 'cuadruple'
  };

  const calculateRoomPrice = () => {
    const hotel = hotelPrecios?.find(h => h.name === hotelName);
    if (!hotel) return 0;

    const keyBase = roomKeyMap[roomType];
    const adultKey = `preciosnadulto${keyBase}`;
    
    const adultPrice = hotel[adultKey] || 0;
    const juniorPrice = hotel.preciosjunior || 0;
    const childPrice = hotel.preciosninos || 0;

    return adults * adultPrice + juniors * juniorPrice + children * childPrice;
  };

  const handleAdd = () => {
    const price = calculateRoomPrice();
    onAddRoom({ hotelId, roomType, adults, juniors, children, price });
    onClose();
  };

  const colorMap = {
    Adultos: 'bg-green-500 hover:bg-green-600',
    'Niños': 'bg-yellow-500 hover:bg-yellow-600',
    'Junior': 'bg-purple-500 hover:bg-purple-600'
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md relative shadow-xl">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="text-lg font-semibold text-gray-800 mb-2">
          {hotelName} - {getRoomTypeName(roomType)}
        </h2>
        <p className="text-sm text-gray-600 mb-4">
          Seleccionar Pasajeros (Máx: {maxCapacity})
        </p>

        {[{
          label: 'Adultos', value: adults, setter: setAdults
        }, {
          label: 'Niños', value: children, setter: setChildren
        }, {
          label: 'Junior', value: juniors, setter: setJuniors
        }].map(({ label, value, setter }) => (
          <div className="flex items-center justify-between mb-2" key={label}>
            <span className="w-20">{label}</span>
            <div className="flex items-center gap-2">
              <button
                onClick={() => decrement(setter, value)}
                className="px-2 py-1 bg-gray-300 rounded"
              >-</button>
              <span className="w-6 text-center">{value}</span>
              <button
                onClick={() => increment(setter, value)}
                className={`px-2 py-1 ${colorMap[label]} rounded text-white`}
              >+</button>
            </div>
          </div>
        ))}

        <div className="mt-4 p-2 bg-blue-100 rounded text-sm">
          Total: {totalPassengers}/{maxCapacity} pasajeros
        </div>

        <div className="mt-2 p-2 bg-green-100 rounded text-sm">
          {adults > 0 && <p>{adults} Adulto{adults > 1 ? 's' : ''}</p>}
          {juniors > 0 && <p>{juniors} Junior{juniors > 1 ? 's' : ''}</p>}
          {children > 0 && <p>{children} Niño{children > 1 ? 's' : ''}</p>}
          <p className="font-bold text-green-700">
            ${calculateRoomPrice().toLocaleString()} MXN
          </p>
        </div>

        <div className="mt-6 flex justify-between gap-2">
          <button
            onClick={onClose}
            className="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded-lg"
          >
            Cancelar
          </button>
          <button
            onClick={handleAdd}
            className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-lg"
          >
            Agregar Habitación
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoomInfoModal;
